/* v22.3.63 — Google Preferred Sources manual integration for occultprintshop.com */
(() => {
  const CANONICAL_DOMAIN = 'occultprintshop.com';
  const DEFAULT_FALLBACK = `https://www.google.com/preferences/source?q=${encodeURIComponent(CANONICAL_DOMAIN)}`;
  let preferredSourceClient = null;

  const triggers = () => Array.from(document.querySelectorAll('[data-ops-google-preferred-source-trigger]'));
  const isLiveHost = () => location.hostname === CANONICAL_DOMAIN || location.hostname === `www.${CANONICAL_DOMAIN}`;
  const fallbackUrl = (trigger) => trigger?.dataset?.fallbackUrl || DEFAULT_FALLBACK;
  const openFallback = (trigger) => { window.location.href = fallbackUrl(trigger); };

  const addPreferredSource = (trigger = null) => {
    if (!isLiveHost() || !preferredSourceClient || typeof preferredSourceClient.addPreferredSource !== 'function') {
      openFallback(trigger);
      return false;
    }
    try {
      preferredSourceClient.addPreferredSource();
      return true;
    } catch (error) {
      openFallback(trigger);
      return false;
    }
  };

  const usePreferredSource = (event) => {
    event.preventDefault();
    addPreferredSource(event.currentTarget);
  };

  const bindTriggers = () => {
    triggers().forEach((trigger) => {
      if (trigger.dataset.opsGoogleBound === 'true') return;
      trigger.dataset.opsGoogleBound = 'true';
      trigger.addEventListener('click', usePreferredSource);
    });
  };

  const initialize = (client) => {
    preferredSourceClient = client;
    try {
      preferredSourceClient.init({ theme: 'light', lang: 'en' });
      document.documentElement.dataset.opsGooglePreferredSource = 'ready';
    } catch (error) {
      document.documentElement.dataset.opsGooglePreferredSource = 'fallback';
    }
    bindTriggers();
  };

  window.OpsGooglePreferredSource = {
    add: () => addPreferredSource(null),
    manageUrl: DEFAULT_FALLBACK,
    isReady: () => Boolean(isLiveHost() && preferredSourceClient && typeof preferredSourceClient.addPreferredSource === 'function')
  };

  self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || [];
  if (typeof self.PREFERRED_SOURCE.push === 'function') self.PREFERRED_SOURCE.push(initialize);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindTriggers, { once: true });
  else bindTriggers();

  document.addEventListener('shopify:section:load', bindTriggers);
})();
